import { bankOperationPageSchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type { BankOperationPage, BankOperationsPageRequest } from '../../model/bank-operation.js';
import type { BankOperationPageDto } from '../dto/bank-operation.dto.js';
import { toBankOperationPage } from '../mappers/bank-operation.mapper.js';

const searchOf = (request: BankOperationsPageRequest): string => {
  const params = new URLSearchParams();

  if (request.year !== null) {
    params.set('year', String(request.year));
  }

  if (request.month !== null) {
    params.set('month', String(request.month));
  }

  if (request.categoryId !== null) {
    params.set('category', request.categoryId);
  }

  if (request.merchantKey !== null) {
    params.set('merchant', request.merchantKey);
  }

  if (request.cursor !== null) {
    params.set('cursor', request.cursor);
  }

  const search = params.toString();

  return search === '' ? '' : `?${search}`;
};

const fetchBankOperations = async (
  request: BankOperationsPageRequest,
  signal: AbortSignal,
): Promise<BankOperationPageDto> =>
  bankOperationPageSchema.parse(
    await apiRequest<unknown>(`/bank/transactions${searchOf(request)}`, { signal }),
  );

export const getBankOperations = async (
  request: BankOperationsPageRequest,
  signal: AbortSignal,
): Promise<BankOperationPage> => toBankOperationPage(await fetchBankOperations(request, signal));
